import apiProxy from "@shared/utils/api-proxy.ts";
import { ResponseType } from "@shared/services/partners/partnerSubscriptions/response.ts";

export default async (crmPartnerId: string) => {
  const response: ResponseType | null = await apiProxy.post(
    `partner/subscriptions`,
    { crmPartnerId },
  );

  if (!response) {
    throw new Error("Got no response from server");
  }

  return response;
};
